console.log('🔥 HMR TEST: main.js loaded', new Date().toISOString())
String.prototype.toTitleCase = function () {
	return this.replace(/\w\S*/g, function (txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
	})
}

// import settings from '../../config/config/settings.json'

import axios from 'axios'

import { computed, createApp, defineAsyncComponent, reactive, ref, nextTick } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import { applyRouteMeta } from './helpers/seoHead'
import VueClipboard from 'vue3-clipboard'
import Vue3TouchEvents from 'vue3-touch-events'
import App from './App.vue'
import SBO from './SBO.vue'
import './index.css'
import mango from './helpers/mango'

const sbo = document?.domain?.includes?.('scottbrownonline')
if (sbo) document.title = 'Scott Brown Online'

/*
    If these are dynamicly imported I end up with a blank
    screen while the route is waiting for the component
    to download... not sure how to fix.
*/

let language = 'english'
let src = language == 'chinese' ? `../src_cn` : `./`

// HAP-4635: the classic homepage only serves /home-classic now — lazy.
const Home = () => import('./components/pages/home.vue')
// HAP-4127 — the artistic showcase is now the published homepage (served at '/').
// Statically imported so the primary landing route isn't a deferred chunk.
import HomeShowcase from './components/pages/home-showcase.vue'
import SboHome from './components/_sbo/blogs.vue'

const Account = () => import('./components/pages/account.vue')
const accountRegistration = () => import('./components/account/registration.vue')
const accountTransactions = () => import('./components/account/transactions.vue')
const accountInfo = () => import('./components/account/info.vue')
const accountIndex = () => import('./components/account/index.vue')
// const accountChat = () => import('./components/account/chat.vue')
const Chat = () => import('./components/pages/chat.vue')
const Donate = () => import('./components/pages/donate.vue')
const AboutParent = () => import('./components/pages/about.vue')
const About = () => import('./components/about/page.vue')
const AboutIndex = () => import('./components/about/index.vue')
const AboutFacilitators = () => import('./components/about/network.vue')
const Events = () => import('./components/pages/events.vue')
const Event = () => import('./components/pages/event-new.vue')
const ChurchEvents = () => import('./components/pages/church-events.vue')
const ChurchEvent = () => import('./components/pages/church-event.vue')
// const EventOld = () => import('./components/pages/event.vue')
const EventLive = () => import('./components/pages/event-live.vue')
const Live = () => import('./components/pages/live.vue')
const EventApp = () => import('./components/pages/event-app.vue')
const AppSchedule = () => import('./components/event-app/schedule.vue')
const AppSpeakers = () => import('./components/event-app/speakers.vue')
const AppExtras = () => import('./components/event-app/extras.vue')
const AppQA = () => import('./components/event-app/qa.vue')
const AppDonate = () => import('./components/event-app/donate.vue')
const AppMessage = () => import('./components/event-app/message-details.vue')
const AppHymns = () => import('./components/event-app/hymns.vue')
const AppSurvey = () => import('./components/event-app/survey.vue')
const AppHome = () => import('./components/event-app/home.vue')
const AppRooms = () => import('./components/event-app/rooms.vue')
const AppPrayerWall = () => import('./components/event-app/prayer-wall.vue')
const AppChecklist = () => import('./components/event-app/checklist.vue')
const AppVenue = () => import('./components/event-app/venue.vue')
const AppBingo = () => import('./components/event-app/bingo.vue')
const AppRecap = () => import('./components/event-app/recap.vue')
const AppDevotional = () => import('./components/event-app/devotional.vue')
const VendorRegistration = () => import('./components/pages/vendor-registration.vue')
const EventChoirMusic = () => import('./components/pages/event-choir-music.vue')
// HAP-4669: The Faith We Confess partnership & vendor page (hidden, like the event)
const FaithWeConfessPartners = () => import('./components/events/bespoke/faith-we-confess-partners.vue')
const EventQuestions = () => import('./components/pages/event-questions.vue')
const RegistrationParent = () => import('./components/pages/registration.vue')
const Attendees = () => import('./components/registration/attendees.vue')
const RelatedEvents = () => import('./components/registration/related-events.vue')
const RegistrationReview = () => import('./components/registration/review.vue')
const Products = () => import('./components/pages/products.vue')
const Liquidation = () => import('./components/pages/liquidation.vue')
const Product = () => import('./components/pages/product.vue')
const Cart = () => import('./components/pages/cart.vue')
const Checkout = () => import('./components/pages/checkout.vue')
const OrderConfirmation = () => import('./components/pages/order-confirmation.vue')
const Churches = () => import('./components/pages/churches.vue')
const NetworkIndex = () => import('./components/pages/network-index.vue')
const NetworkLanding = () => import('./components/pages/network-landing.vue')
const Church = () => import('./components/pages/church.vue')
const CreateChurch = () => import('./components/pages/church-create.vue')
const SermonDashboard = () => import('./components/pages/sermon-dashboard.vue')
const ChurchDirectoryDashboard = () => import('./components/hub/families/index.vue')
const ChurchDirectory = () => import('./components/pages/church-directory.vue')
const ChurchDashboard = () => import('./components/pages/church-hub.vue')
const EditProfile = () => import('./components/hub/edit-profile.vue')
const JobListings = () => import('./components/hub/jobs/jobs.vue')
const Jobs = () => import('./components/hub/jobs/index.vue')
const Job = () => import('./components/hub/jobs/job.vue')
const CreateJobListing = () => import('./components/hub/jobs/create-listing.vue')
const CreateFamily = () => import('./components/hub/families/create-family.vue')
const Emailer = () => import('./components/hub/emailer/index.vue')
const CreateEmail = () => import('./components/hub/emailer/create-email.vue')
const Marketplace = () => import('./components/hub/marketplace/index.vue')
const ChurchMarketplace = () => import('./components/hub/marketplace/marketplace.vue')
const CreateMarketplaceListing = () => import('./components/hub/marketplace/create-listing.vue')
const HubSermonDashboard = () => import('./components/hub/sermon-dashboard.vue')
const HubSettings = () => import('./components/hub/settings.vue')
const AiTools = () => import('./components/hub/ai-tools.vue')
const ChurchHubEvents = () => import('./components/hub/events/index.vue')
const CreateChurchHubEvent = () => import('./components/hub/events/create-event.vue')
const ChurchHubEventRegistrations = () => import('./components/hub/events/registrations.vue')
const UploadSermon = () => import('./components/pages/upload-sermon.vue')
const Sermons = () => import('./components/pages/sermons.vue')
const SermonsHub = () => import('./components/pages/sermons-hub.vue')
const SermonsDirectory = () => import('./components/pages/sermons-directory.vue')
const EmbedSermons = () => import('./components/pages/embed-sermons.vue')
const EmbedDirectory = () => import('./components/pages/embed-directory.vue')
const EmbedEvents = () => import('./components/pages/embed-events.vue')
const Sermon = () => import('./components/pages/sermon.vue')
const ActivityPage = () => import('./components/pages/activity-page.vue')
const TraceScripture = () => import('./components/pages/trace-scripture.vue')
const MathLab = () => import('./components/pages/math-lab.vue')
const Resources = () => import('./components/pages/resources.vue')
const Devotionals = () => import('./components/pages/devotionals.vue')
const DevotionalReview = () => import('./components/pages/devotional-review.vue')
const DevotionalReviewIndex = () => import('./components/pages/devotional-review-index.vue')
const Resource = () => import('./components/pages/resource.vue')
const TranslatedResource = () => import('./components/pages/translated-resource.vue')
const OfflineLibrary = () => import('./components/pages/offline.vue')
const Invoice = () => import('./components/pages/invoice.vue')
const Survey = () => import('./components/pages/survey.vue')
const SurveyResponses = () => import('./components/pages/survey-responses.vue')
const PodcastsIndex = () => import('./components/pages/podcasts-index.vue')
const Podcasts = () => import('./components/pages/podcasts.vue')
const PodcastCollection = () => import('./components/pages/podcast-collection.vue')
const Timers = () => import('./components/pages/timers.vue')
const Timer = () => import('./components/pages/timer.vue')
const TimerCreate = () => import('./components/pages/timer-create.vue')
const Chinese = () => import('./components/pages/chinese.vue')
const Spanish = () => import('./components/pages/spanish.vue')
const Mission = () => import('./components/pages/mission.vue')
const EsAbout = () => import('./components/pages/es-about.vue')
const EsAboutPage = () => import('./components/pages/es-about-page.vue')
const EsRecursos = () => import('./components/pages/es-recursos.vue')
const Covid = () => import('./components/pages/covid.vue')
const Community = () => import('./components/pages/community.vue')

const FamilyAtChurchCn = () => import('./components/books/family-at-church-cn.vue')
const FeminineByDesignCn = () => import('./components/books/feminine-by-design-cn.vue')
const TheologyOfTheFamilyCn = () => import('./components/books/theology-of-the-family-cn.vue')
const GenericBook = () => import('./components/books/generic.vue')

const FeminineByDesignEs = () => import('./components/books/feminine-by-design-es.vue')

const WTDFunnel = () => import('./components/pages/wtd-funnel.vue')
const FeaturedResources = () => import('./components/pages/featured-resources.vue')
const ScheduleDevotionals = () => import('./components/pages/schedule-devotionals.vue')
const WriteReview = () => import('./components/pages/write-review.vue')

const PostBlog = () => import('./components/pages/post-blog.vue')
const WaitingList = () => import('./components/pages/waiting-list.vue')
// const SermonResearch = () => import('./components/pages/sermon-research.vue')
const EBookLanding = () => import('./components/pages/ebook-landing.vue')
const EditSermon = () => import('./components/pages/edit-sermon.vue')
const NetworkSignup = () => import('./components/pages/network-signup.vue')
const AiTranslation = () => import('./components/pages/ai-translate.vue')
const AiJourney = () => import('./components/pages/ai-journey.vue')
const GThreeLanding = () => import('./components/pages/gthreelanding.vue')
const BibleMemory = () => import('./components/pages/bible-memory.vue')
const FacilitatorDashboard = () => import('./components/pages/facilitator-dashboard.vue')
const ClosedChurchesDashboard = () => import('./components/pages/closed-churches-dashboard.vue')
const ChurchProspectsDashboard = () => import('./components/pages/church-prospects-dashboard.vue')
const EmailCheckDashboard = () => import('./components/pages/email-check-dashboard.vue')
const WebsiteRefreshDashboard = () => import('./components/pages/website-refresh-dashboard.vue')
const ClosureCheckDashboard = () => import('./components/pages/closure-check-dashboard.vue')
const FacilitatorLeaders = () => import('./components/pages/facilitator-leaders.vue')
const FacilitatorReports = () => import('./components/pages/facilitator-reports.vue')
const FacilitatorReport = () => import('./components/pages/facilitator-report.vue')
const EventRegistrations = () => import('./components/pages/event-registrations.vue')
const RegistrationPrintPackets = () => import('./components/pages/registration-print-packets.vue')
const Marriage = () => import('./components/pages/marriage.vue')
const FatherSon = () => import('./components/pages/father-son-retreat.vue')
const FatherDaughter = () => import('./components/pages/father-daughter-retreat.vue')
const Bible = () => import('./components/pages/bible.vue')

const Blog = () => import('./components/_sbo/blog-page.vue')
const SboAbout = () => import('./components/_sbo/about.vue')
const SboInvitation = () => import('./components/_sbo/invitation.vue')

const Search = () => import('./components/pages/search.vue')
const Playground = () => import('./components/pages/playground.vue')

const Singles = () => import('./components/pages/singles/singles.vue')
const FreeBook = () => import('./components/pages/singles/freebook.vue')
const Burnings = () => import('./components/pages/singles/burnings.vue')
const ChiefEnd = () => import('./components/pages/singles/chiefend.vue')
const OutreachUpdate = () => import('./components/pages/singles/outreach-update.vue')
const DecemberReport = () => import('./components/pages/singles/december-report.vue')
const NovemberReport = () => import('./components/pages/singles/november-report.vue')
const BuildWithUs = () => import('./components/pages/singles/build-with-us.vue')
const JuneReport = () => import('./components/pages/singles/june-report.vue')
const HurricaneReport = () => import('./components/pages/singles/hurricane-report.vue')
const Ridgecrest24 = () => import('./components/pages/singles/ridgecrest24.vue')
const TreasureHunt = () => import('./components/pages/singles/treasure-hunt.vue')
const DonorCampaign = () => import('./components/pages/singles/2024-donor-campaign.vue')
const PastorsWelcome = () => import('./components/pages/pastors-welcome.vue')
const RestoreFamilyWorship = () => import('./components/pages/singles/restore-family-worship.vue')
const RfwStarterKit = () => import('./components/pages/singles/rfw-starter-kit.vue')
const RfwGuide = () => import('./components/pages/singles/rfw-guide.vue')
const RfwCampaignAssets = () => import('./components/pages/singles/rfw-campaign-assets.vue')
const RfwEmailTemplates = () => import('./components/pages/singles/rfw-email-templates.vue')
const RfwConfirmation = () => import('./components/pages/singles/rfw-confirmation.vue')
const RfwBookmarkRequest = () => import('./components/pages/singles/rfw-bookmark-request.vue')
const RfwEnrollDaily = () => import('./components/pages/singles/rfw-enroll-daily.vue')
const RfwFosterKeepItSimple = () => import('./components/pages/singles/rfw-foster-keep-it-simple.vue')
const RfwFosterSpilledMilk = () => import('./components/pages/singles/rfw-foster-spilled-milk.vue')
const WorshipTogether = () => import('./components/pages/singles/worship-together.vue')
const FamilyWorshipPastor = () => import('./components/pages/singles/family-worship-pastor.vue')
const Stay = () => import('./components/pages/singles/stay.vue')
const JimZes = () => import('./components/pages/singles/jim-zes.vue')
const WtStarterKit = () => import('./components/pages/singles/wt-starter-kit.vue')
const WtStarterKitEs = () => import('./components/pages/singles/wt-starter-kit-es.vue')
const WtEmailTemplates = () => import('./components/pages/singles/wt-email-templates.vue')
const WtCampaignAssets = () => import('./components/pages/singles/wt-campaign-assets.vue')
const WtConfirmation = () => import('./components/pages/singles/wt-confirmation.vue')
const WtBookmarkRequest = () => import('./components/pages/singles/wt-bookmark-request.vue')
const WtEnrollDaily = () => import('./components/pages/singles/wt-enroll-daily.vue')
const WtPastors = () => import('./components/pages/singles/wt-pastors.vue')
const OldSchool = () => import('./components/pages/singles/old-school.vue')
const QuietFaithfulness = () => import('./components/pages/singles/quiet-faithfulness.vue')
const Audiobook = () => import('./components/pages/audiobook.vue')
const BookmarkOrdersAdmin = () => import('./components/pages/singles/bookmark-orders-admin.vue')
const InventoryAdmin = () => import('./components/pages/singles/inventory-admin.vue')
const Campaigns = () => import('./components/pages/singles/campaigns.vue')
const CampaignPreview = () => import('./components/pages/campaign-preview.vue')
const BookWholesale = () => import('./components/pages/singles/wholesale/BookWholesale.vue')

const ManageChoirKids = () => import('./components/pages/manage-choir-kids.vue')
const conferenceAds = () => import('./components/pages/conference-ads.vue')
const conferenceAdsIndex = () => import('./components/pages/conference-ads-index.vue')

const Study = () => import('./components/pages/study.vue')

const Contact = () => import('./components/pages/contact.vue')
const ChurchDiscount = () => import('./components/pages/church-discount.vue')

const Transcriptions = () => import('./components/pages/transcriptions.vue')
const Transcription = () => import('./components/pages/transcription.vue')

const Kirk = () => import('./components/pages/kirk.vue')

const SpeakerAttendance = () => import('./components/pages/speaker-attendance.vue')

import fourOhFour from './components/pages/404.vue'
// import Dumb from './components/pages/dumb.vue'

// JZDJ Redirect
if (window.location.href == 'https://jzdj.xyz/') window.location.replace('https://jzdj.xyz/books/61fd9ba66526838c4ac16912')

// Sticky preview flag (HAP-4214/HAP-4162). `initUser()` below is NOT awaited, so a cold
// deep-link to a protected route (e.g. the church profile editor) races the async auth
// hydration and the beforeEach guard bounces it to /account — dropping the ?preview query
// on the way (store.login.next stores to.path without the query). Capture ?preview here,
// synchronously, before the router exists, and stash it for the whole tab session so
// preview-gated redesigns keep rendering across that bounce, the subsequent login redirect,
// and any full reload. Public visitors never carry the flag, so the public flow is unaffected.
try {
	const pv = new URLSearchParams(window.location.search).get('preview')
	// ?preview=0 leaves preview mode for the rest of the tab session (HAP-4486).
	if (pv === '0') window.sessionStorage.removeItem('preview')
	else if (pv) window.sessionStorage.setItem('preview', pv)
} catch (e) {}

// HAP-4255 test-mode switch. Same sticky mechanism as ?preview above (the wizard route strips
// the query on the auth bounce): capture ?test once, synchronously, and keep it for the tab
// session so a staff tester can create/save churches from the Add-Church flow WITHOUT firing
// the signup emails (churches `updated` hook reads the previewTest flag the front sets when
// this is on). ?test=0 clears it. Public visitors never append ?test, so the public flow is
// unaffected — and this is independent of the layout preview level, so promoting a preview to
// public never turns email suppression on for real signups.
try {
	const tm = new URLSearchParams(window.location.search).get('test')
	if (tm === '0') window.sessionStorage.removeItem('churchTest')
	else if (tm) window.sessionStorage.setItem('churchTest', tm)
} catch (e) {}

const routes = sbo
	? [
			{ path: '/', component: SboHome },
			{ path: '/blogs', component: SboHome },
			{ path: '/blogs/:id', component: Blog },
			{ path: '/about', component: SboAbout },
			{ path: '/invite', component: SboInvitation },

			{
				path: '/account',
				component: Account,
				children: [{ path: '', component: accountIndex }],
			},
		]
	: [
			// { path: '/dumb', component: Dumb },

			{ path: '/', component: HomeShowcase },

			// HAP-4127 — previous production homepage, kept reachable for rollback/reference.
			{ path: '/home-classic', component: Home },
			// HAP-4127 — legacy preview URL; keeps working now that the showcase is live at '/'.
			{ path: '/showcase', component: HomeShowcase },

			{ path: '/kirk', component: Kirk },

			{ path: '/search', component: Search },

			{ path: '/contact', component: Contact },
			{ path: '/contact-us', component: Contact },
			{ path: '/support', component: Contact },

			{ path: '/church-discount', component: ChurchDiscount },

			{
				path: '/sermons/:id/edit',
				component: EditSermon,
				// meta: {
				//     protected: true,
				//     fallback: '/edit/:collection'
				// },
			},

			{ path: '/facilitator-dashboard', component: FacilitatorDashboard, meta: { protected: ['facilitator', 'advocate', 'networkStaff'], fallback: '/account' } },
			{ path: '/facilitator-dashboard/:id', component: FacilitatorDashboard, meta: { protected: ['facilitator', 'advocate'], fallback: '/account' } },
			{ path: '/closed-churches', component: ClosedChurchesDashboard, meta: { protected: ['facilitator', 'advocate', 'networkStaff'], fallback: '/account' } },
			// HAP-5107: outreach list of prospective churches, worked state by state.
			{ path: '/church-prospects', component: ChurchProspectsDashboard, meta: { protected: ['facilitator', 'advocate', 'networkStaff'], fallback: '/account' } },
			{ path: '/email-check', component: EmailCheckDashboard, meta: { protected: ['facilitator', 'advocate', 'networkStaff'], fallback: '/account' } },
			// HAP-4815: siteBuilder = Happy Path builders (Ivan) — this page only.
			{ path: '/website-refresh', component: WebsiteRefreshDashboard, meta: { protected: ['facilitator', 'advocate', 'networkStaff', 'siteBuilder'], fallback: '/account' } },
			{ path: '/closure-check', component: ClosureCheckDashboard, meta: { protected: ['facilitator', 'advocate', 'networkStaff'], fallback: '/account' } },
			{ path: '/facilitator-leaders', component: FacilitatorLeaders, meta: { protected: ['facilitator', 'advocate'], fallback: '/account' } },
			{ path: '/facilitator-leaders/:id', component: FacilitatorLeaders, meta: { protected: ['facilitator', 'advocate'], fallback: '/account' } },
			{ path: '/facilitator-reports/:id', component: FacilitatorReport, meta: { protected: ['facilitator', 'advocate'], fallback: '/account' } },
			{ path: '/facilitator-reports', component: FacilitatorReports, meta: { protected: ['facilitator', 'advocate'], fallback: '/account' } },
			{ path: '/events/:id/registrations', component: EventRegistrations, meta: { protected: ['admin'], fallback: '/account' } },
			{ path: '/events/:id/registrations/print/packets', component: RegistrationPrintPackets, meta: { protected: ['admin'], fallback: '/account' } },
			// { path: '/facilitator-reports/:id', component: FacilitatorReports },

			{ path: '/bibleMemory', component: BibleMemory },
			{ path: '/20days', component: GThreeLanding },
			{ path: '/20-day-challenge', component: GThreeLanding },
			{ path: '/ebooklanding/:collection/:id', component: EBookLanding },

			{ path: '/outreach-update', component: OutreachUpdate },
			{ path: '/december-report', component: DecemberReport },
			{ path: '/november-report', component: NovemberReport },
			{ path: '/build-with-us', component: BuildWithUs },
			{ path: '/june-report', component: JuneReport },
			{ path: '/hurricane-report', component: HurricaneReport },
			{ path: '/ridgecrest24', component: Ridgecrest24 },
			{ path: '/treasure-hunt', component: TreasureHunt },
			{ path: '/singles-report', component: Singles },
			{ path: '/burnings-report', component: Burnings },
			{ path: '/chiefend-report', component: ChiefEnd },
			{ path: '/freebook', component: FreeBook },

			{ path: '/math-lab', component: MathLab },

			{ path: '/chat', component: Chat },

			{
				path: '/account',
				component: Account,
				children: [
					{ path: '', component: accountIndex },
					{ path: 'reset-password', component: accountIndex },
					{ path: 'info', component: accountInfo },
					{ path: 'transactions', component: accountTransactions },
					{ path: 'registration/:id', component: accountRegistration },
					// { path: 'chat', component: accountChat },
				],
			},

			{ path: '/donate', component: Donate },
			// HAP-4579: cf.life/70percent → donate page with the "70% walk away" video overlay open
			{ path: '/70percent', redirect: { path: '/donate', query: { video: 'LnaGcquC7MU' } } },

			{
				path: '/about',
				component: AboutParent,
				children: [
					{ path: '', component: AboutIndex },
					{ path: 'network', component: AboutFacilitators },
					// Superseded Transaction Policy -> combined Policies page (HAP-3501)
					{ path: '60cd1a416d05214482e37bff', redirect: '/about/6a70efd7d4ba2deb720c1c4f' },
					{ path: ':id', component: About },
				],
			},

			{
				path: '/events/:id/app',
				component: EventApp,
				children: [
					{ path: '', component: AppHome },
					{ path: 'home', component: AppHome },
					{ path: 'schedule', component: AppSchedule },
					{ path: 'schedule/:messageId', component: AppMessage },
					{ path: 'speakers', component: AppSpeakers },
					{ path: 'qa', component: AppQA },
					{ path: 'donate', component: AppDonate },
					{ path: 'extras', component: AppExtras },
					{ path: 'hymns', component: AppHymns },
					{ path: 'rooms', component: AppRooms },
					{ path: 'prayer-wall', component: AppPrayerWall },
					{ path: 'checklist', component: AppChecklist },
					{ path: 'venue', component: AppVenue },
					{ path: 'bingo', component: AppBingo },
					{ path: 'recap', component: AppRecap },
					{ path: 'survey', component: AppSurvey },
					{ path: 'devotional', component: AppDevotional },
				],
			},

			{ path: '/study', component: Study },

			{ path: '/live', component: Live },
			{ path: '/events', component: Events },
			{ path: '/events/:id', component: Event },
			{ path: '/events/:id/new', component: Event },
			// { path: '/events/:id/live', component: EventLive, meta: { protected: true, fallback: '/events/:id' }, },
			{ path: '/events/:id/live', component: EventLive },
			{ path: '/events/:id/vendor-registration', component: VendorRegistration },
			{ path: '/events/:id/choir-music', component: EventChoirMusic },
			{ path: '/events/:id/partners', component: FaithWeConfessPartners },
			{ path: '/events/:id/questions', component: EventQuestions, meta: { protected: true, fallback: '/events/:id' } },

			{
				path: '/events/:id/registration',
				component: RegistrationParent,
				meta: { protected: true, fallback: '/events/:id' },
				children: [
					{ path: 'attendees', component: Attendees },
					{ path: 'payment', component: Attendees },
					{ path: 'related-events', component: RelatedEvents },
					{ path: 'review', component: RegistrationReview },
				],
			},

			{ path: '/products', component: Products },
			{ path: '/liquidation', component: Liquidation },
			{ path: '/products/:id', component: Product },
			{ path: '/bundles/:id', component: Product },
			{ path: '/store', component: Products },
			{ path: '/store/:id', component: Product },

			{ path: '/invoices/:id', component: Invoice },
			{ path: '/surveys/:id', component: Survey },
			{ path: '/surveys/:id/responses', component: SurveyResponses, meta: { protected: true, fallback: '/account' } },

			{ path: '/transcriptions', component: Transcriptions, meta: { protected: true, fallback: '/account' } },
			{ path: '/transcriptions/:id', component: Transcription, meta: { protected: true, fallback: '/account' } },

			{ path: '/cart', component: Cart },
			{ path: '/cart/checkout', component: Checkout },
			{ path: '/order-confirmation', component: OrderConfirmation },

			{ path: '/network/signup', component: NetworkSignup, meta: { protected: false, fallback: '/account' } },
			{ path: '/network/signup/:churchId', component: NetworkSignup, meta: { protected: true, fallback: '/account' } },
			{ path: '/network', component: Churches },
			{ path: '/network/landing', component: NetworkLanding },
			{ path: '/network/index', component: NetworkIndex },
			{ path: '/network/:id', component: Church },

			{ path: '/network/:churchId/events', component: ChurchEvents },
			{ path: '/network/:churchId/events/:id', component: ChurchEvent },
			{ path: '/network/:churchId/directory', component: ChurchDirectory, meta: { protected: true, fallback: '/account' } },
			{ path: '/network/:churchId/directory/:tab', component: ChurchDirectory, meta: { protected: true, fallback: '/account' } },
			{ path: '/network/:churchId/families/edit/:familyId', component: CreateFamily, meta: { protected: true, fallback: '/account' } },
			{ path: '/network/:churchId/families/create', component: CreateFamily, meta: { protected: true, fallback: '/account' } },

			{ path: '/network/create', component: NetworkSignup, meta: { protected: true, fallback: '/account' } },
			// { path: '/network/create/:id', component: CreateChurch, meta: { protected: true, fallback: '/account' }, },
			// { path: '/network/edit/:id', component: CreateChurch, meta: { protected: true, fallback: '/account' }, },

			{
				path: '/network/:churchId/dashboard',
				component: ChurchDashboard,
				meta: { protected: true, fallback: '/account' },
				children: [
					{ path: '', component: EditProfile },
					{ path: 'profile', component: EditProfile },
					{ path: 'profile/:tab', component: EditProfile },
					{ path: 'settings', component: HubSettings },
					{ path: 'sermons', component: HubSermonDashboard },
					{ path: 'sermons/upload', component: UploadSermon },
					{ path: 'sermons/:tab', component: HubSermonDashboard },
					{ path: 'directory', component: ChurchDirectoryDashboard },
					{ path: 'directory/:tab', component: ChurchDirectoryDashboard },
					{ path: 'jobs', component: JobListings },
					{ path: 'jobs/create', component: CreateJobListing },
					{ path: 'jobs/edit/:id', component: CreateJobListing },
					{ path: 'marketplace', component: ChurchMarketplace },
					{ path: 'marketplace/create', component: CreateMarketplaceListing },
					{ path: 'families/edit/:familyId', component: CreateFamily },
					{ path: 'families/create', component: CreateFamily },
					{ path: 'ai-tools', component: AiTools },
					{ path: 'events', component: ChurchHubEvents },
					{ path: 'events/create', component: CreateChurchHubEvent },
					{ path: 'events/:id', component: CreateChurchHubEvent },
					{ path: 'events/:id/registrations', component: ChurchHubEventRegistrations },
					// { path: 'ai-tools/trace-scripture', component: ActivityPage },
					// { path: 'ai-tools/activity-page', component: TraceScripture },
					{ path: 'emails', component: Emailer },
					{ path: 'emails/create', component: CreateEmail },
					{ path: 'emails/:emailId', component: CreateEmail },
				],
			},

			{ path: '/jobs', component: Jobs, meta: { protected: true, fallback: '/account' } },
			{ path: '/jobs/:id', component: Job, meta: { protected: true, fallback: '/account' } },
			{ path: '/marketplace', component: Marketplace, meta: { protected: true, fallback: '/account' } },

			// { path: '/network/:id/directory', component: ChurchDirectory, },//meta: { protected: true, fallback: '/account' }, },
			{ path: '/network/:id/sermon-dashboard', component: SermonDashboard }, //meta: { protected: true, fallback: '/account' }, },
			{ path: '/network/:id/sermon-dashboard/upload', component: UploadSermon }, //meta: { protected: true, fallback: '/account' }, },

			{ path: '/sermons', component: Sermons },
			{ path: '/sermons/:id', component: Sermon },
			// HAP-4387: crawlable hub pages per speaker / church / series, plus their directories.
			// The :slug is cosmetic (ids are the key; CMS slugs are not unique).
			{ path: '/sermons/speakers', component: SermonsDirectory, meta: { hubType: 'speaker' } },
			{ path: '/sermons/churches', component: SermonsDirectory, meta: { hubType: 'church' } },
			{ path: '/sermons/series', component: SermonsDirectory, meta: { hubType: 'series' } },
			{ path: '/sermons/speakers/:hubId/:slug?', component: SermonsHub, meta: { hubType: 'speaker' } },
			{ path: '/sermons/churches/:hubId/:slug?', component: SermonsHub, meta: { hubType: 'church' } },
			{ path: '/sermons/series/:hubId/:slug?', component: SermonsHub, meta: { hubType: 'series' } },
			{ path: '/sermons/embed/church/:churchId', component: EmbedSermons },
			{ path: '/directory/embed/church/:churchId', component: EmbedDirectory },
			{ path: '/events/embed/church/:churchId', component: EmbedEvents },

			{ path: '/trace-scripture/create', component: TraceScripture },
			{ path: '/activity-page/create', component: ActivityPage },

			{ path: '/devotionals', component: Devotionals, meta: { redirect: `/podcasts/living-biblically` } },

			{ path: '/resources', component: Resources },
			{ path: '/resources/offline', component: OfflineLibrary },
			{ path: '/resources/authors/:authorId', component: Resources },
			{ path: '/resources/series/:seriesId', component: Resources },
			{ path: '/resources/topics/:topicId', component: Resources },
			{ path: '/resources/date/:year', component: Resources },
			{ path: '/resources/:id/:language', component: TranslatedResource },
			// HAP-4298: closed 2013 re-import duplicate → published 2004 original (dead shortlink target)
			{ path: '/resources/children-in-the-meeting-of-the-ephesian-church-ephesians-614', redirect: '/resources/children-in-the-meeting-of-the-ephesian-church' },
			{ path: '/resources/:id', component: Resource },
			{ path: '/blogs/:id', component: Resource },

			{ path: '/devotional-review', component: DevotionalReviewIndex, meta: { protected: true, fallback: '/account' } },
			{ path: '/devotional-review/:id', component: DevotionalReview, meta: { protected: true, fallback: '/account' } },

			// { path: '/scripture-applied', component: Podcasts },
			// { path: '/scripture-applied/:id', component: Podcasts },

			// { path: '/living-biblically', component: Podcasts },
			// { path: '/living-biblically/:id', component: Podcasts },

			{ path: '/podcasts', component: PodcastsIndex },
			{ path: '/podcasts/collections/:id', component: PodcastCollection },
			// { path: '/podcasts/scripture-applied', component: Podcasts },
			// { path: '/podcasts/:id', component: Podcasts },
			// Until Old School launches (midnight ET Oct 19, same instant as the landing
			// page countdown) its show page has no episodes, so send visitors to the
			// landing page instead. Stops redirecting on its own at launch (HAP-4489).
			{ path: '/podcasts/:podcastId(old-school)', component: Podcasts, beforeEnter: () => Date.now() < Date.parse('2026-10-19T04:00:00Z') ? { path: '/old-school', replace: true } : true },
			// Same pre-launch redirect for Quiet Faithfulness — midnight ET Nov 12 (EST) (HAP-4709).
			{ path: '/podcasts/:podcastId(quiet-faithfulness)', component: Podcasts, beforeEnter: () => Date.now() < Date.parse('2026-11-12T05:00:00Z') ? { path: '/quiet-faithfulness', replace: true } : true },
			{ path: '/podcasts/:podcastId', component: Podcasts },
			{ path: '/podcasts/:podcastId/:id', component: Podcasts },

			{ path: '/books/61fd9ba66526838c4ac16912', component: FamilyAtChurchCn },
			{ path: '/books/61fd9ba66526838c4ac16912/:chapterId', component: FamilyAtChurchCn },

			{ path: '/books/62f6b06b721670bfb3c73eeb', component: FeminineByDesignCn },
			{ path: '/books/62f6b06b721670bfb3c73eeb/:chapterId', component: FeminineByDesignCn },

			{ path: '/books/65e61b12c1998f60c611ca4e', component: FeminineByDesignEs },
			{ path: '/books/65e61b12c1998f60c611ca4e/:chapterId', component: FeminineByDesignEs },

			{ path: '/books/62fe8f72a2bff874b7c40e36', component: TheologyOfTheFamilyCn },
			{ path: '/books/62fe8f72a2bff874b7c40e36/:chapterId', component: TheologyOfTheFamilyCn },
			{ path: '/books/62fe8f72a2bff874b7c40e36/:chapterId/:sectionId', component: TheologyOfTheFamilyCn },

			{ path: '/books/666c994a8ca555610fd2b86b', component: TheologyOfTheFamilyCn },
			{ path: '/books/666c994a8ca555610fd2b86b/:chapterId', component: TheologyOfTheFamilyCn },
			{ path: '/books/666c994a8ca555610fd2b86b/:chapterId/:sectionId', component: TheologyOfTheFamilyCn },

			{ path: '/books/:bookId', component: GenericBook },
			{ path: '/books/:bookId/:chapterId', component: GenericBook },

			{ path: '/timers', component: Timers, meta: { protected: true } },
			{ path: '/timers/create', component: TimerCreate, meta: { protected: true } },
			{ path: '/timers/:id', component: Timer },
			{ path: '/timers/create/:id', component: TimerCreate, meta: { protected: true } },
			{ path: '/timers/edit/:id', component: TimerCreate, meta: { protected: true } },

			{ path: '/covid', component: Covid },
			{ path: '/cn', component: Chinese },
			{ path: '/mission', component: Mission },
			{ path: '/es', component: Spanish },
			{ path: '/es/recursos', component: EsRecursos },
			{
				path: '/es/about',
				component: EsAbout,
				children: [
					{ path: '', redirect: '/es/about/the-mission-of-the-ncfic' },
					{ path: ':slug', component: EsAboutPage },
				],
			},

			{ path: '/community', component: Community },

			{ path: '/family', component: DonorCampaign },
			{ path: '/family/:topic', component: DonorCampaign },
			// HAP-4919: Welcome Pastors on the Family v2 design; ?preview=1 only, otherwise it goes to /about/60cd1a4e…
			{ path: '/pastors-welcome/:topic?', component: PastorsWelcome },

			{ path: '/campaigns', component: Campaigns },
			{ path: '/campaign-preview', component: CampaignPreview },

			{ path: '/wholesale/:book', component: BookWholesale },

			{ path: '/restore-family-worship', component: RestoreFamilyWorship },
			{ path: '/restore-family-worship/starter-kit', component: RfwStarterKit },
			{ path: '/kit', component: RfwStarterKit },
			{ path: '/restore-family-worship/guide', component: RfwGuide },
			{ path: '/restore-family-worship/campaign-assets', component: RfwCampaignAssets },
			{ path: '/restore-family-worship/email-templates', component: RfwEmailTemplates },
			{ path: '/restore-family-worship/confirmation', component: RfwConfirmation },
			{ path: '/restore-family-worship/bookmark-request', component: RfwBookmarkRequest },
			{ path: '/restore-family-worship/enroll-daily', component: RfwEnrollDaily },
			{ path: '/restore-family-worship/foster-keep-it-simple', component: RfwFosterKeepItSimple },
			{ path: '/restore-family-worship/foster-spilled-milk', component: RfwFosterSpilledMilk },

			{ path: '/worship-together', component: WorshipTogether },
			{ path: '/worship-together/starter-kit', component: WtStarterKit },
			{ path: '/worship-together/starter-kit-es', component: WtStarterKitEs },
			{ path: '/worship-together/email-templates', component: WtEmailTemplates },
			{ path: '/worship-together/campaign-assets', component: WtCampaignAssets },
			{ path: '/worship-together/confirmation', component: WtConfirmation },
			{ path: '/worship-together/bookmark-request', component: WtBookmarkRequest },
			{ path: '/worship-together/enroll-daily', component: WtEnrollDaily },
			{ path: '/worship-together/pastors', component: WtPastors },
			{ path: '/old-school', component: OldSchool },
			{ path: '/quiet-faithfulness', component: QuietFaithfulness },
			// HAP-4591: audiobooks narrated in the author's voice; the player bar is in App.vue
			{ path: '/audiobooks/:slug', component: Audiobook },

			{ path: '/family-worship-pastor', component: FamilyWorshipPastor },
			{ path: '/pastors', component: FamilyWorshipPastor },

			// Re-engagement confirmation page. `?topic=` is the form baked into the
			// scheduled emails; `/stay/:topic` is registered too so either style of
			// link resolves. Unknown topics fall back to the plain copy. (HAP-3172)
			{ path: '/stay', component: Stay },
			{ path: '/stay/:topic', component: Stay },

			{ path: '/admin/bookmark-orders', component: BookmarkOrdersAdmin, meta: { protected: true } },
			{ path: '/admin/inventory', component: InventoryAdmin, meta: { protected: true } },

			{ path: '/jim-zes', component: JimZes },
			{ path: '/remembering-jim-zes', component: JimZes },

			{ path: '/when-to-disobey', component: WTDFunnel },
			{ path: '/for-david', component: FeaturedResources, meta: { protected: false } },
			{ path: '/feature-resources', component: FeaturedResources, meta: { protected: true } },
			{ path: '/review/:productId', component: WriteReview },

			{ path: '/marriage', component: Marriage },
			{ path: '/fsr', component: FatherSon },
			{ path: '/fdr', component: FatherDaughter },

			{ path: '/bible', component: Bible, meta: { protected: true } },

			{ path: '/sbblog', component: PostBlog, meta: { protected: true } },
			{ path: '/schedule-devotionals', component: ScheduleDevotionals, meta: { protected: true } },
			// { path: '/sermon-research', component: SermonResearch, meta: { protected: false } },
			// { path: '/ai-research', component: SermonResearch, meta: { protected: false } },
			{ path: '/events/:id/waitingList', component: WaitingList, meta: { protected: true } },

			{ path: '/registrations/:id/choir', component: ManageChoirKids, meta: { protected: true } },
			{ path: '/ads', component: conferenceAdsIndex },
			{ path: '/ads/:id', component: conferenceAds },
			{ path: '/speaker-attendance', component: SpeakerAttendance },

			{ path: '/ai-translation', component: AiTranslation, meta: { protected: true } },
			{ path: '/ai-journey', component: AiJourney, meta: { protected: true } },
			{ path: '/ai-journey/:id', component: AiJourney, meta: { protected: true } },

			{ name: '404', path: '/:pathMatch(.*)*', component: fourOhFour },
		]

if (process.env.NODE_ENV != 'production') {
	routes.push({ path: '/playground', component: Playground })
}

// Add 'church-network' routes
routes.filter((r) => r.path.includes('network')).forEach((r) => routes.push({ ...r, path: r.path.replace('network', 'church-network') }))

// Add /:slug to /:id routes
routes
	.filter((r) => r.path.includes(':id') && ['resources', 'podcasts', 'network', 'church-network', 'aboutPages', 'events', 'products'].some((c) => r.path.includes(c)))
	.forEach((r) => {
		routes.push({ ...r, path: r.path.replace(':id', ':id/:slug') })
		if (r.path.includes('events')) routes.push({ ...r, path: r.path.replace(':id', ':id/:slug/:section') })
	})

let mountedDirective = {
	mounted(el) {
		console.log('mounted')
		el.dispatchEvent(new CustomEvent('mounted'))
	},
}

// Haptics directive (HAP-1886, parent HAP-1884 Phase 0.2). `v-haptic` fires a
// short pulse on tap; `v-haptic:medium` / `:success` etc. pick a named pattern.
// Bound on `pointerdown` so the buzz lands inside the user gesture (required by
// the Vibration API) and feels immediate. Safely no-ops where unsupported.
import { useHaptics } from './composables/useHaptics'
const haptics = useHaptics()
let hapticDirective = {
	mounted(el, binding) {
		el.__haptic = () => {
			const kind = binding.arg || 'light'
			;(haptics[kind] || haptics.light)()
		}
		el.addEventListener('pointerdown', el.__haptic, { passive: true })
	},
	unmounted(el) {
		if (el.__haptic) el.removeEventListener('pointerdown', el.__haptic)
	},
}

// Pressable micro-interaction directive (HAP-1891, parent HAP-1884 Phase 3.1).
// `v-press` gives buttons/cards/list rows one consistent spring scale-down +
// optional haptic on press, replacing ad-hoc `active:scale-*`. Reduced-motion
// aware and never clobbers existing CSS transforms/transitions (WAAPI-driven).
import { pressDirective } from './directives/press'

// Staggered scroll-reveal directive (HAP-1893, parent HAP-1884 Phase 3.3).
// `v-reveal="index"` fades + rises list/grid items in once on scroll-in, offset
// by their position so a grid cascades. Stagger is capped and reduced-motion is
// a full no-op (item renders immediately). WAAPI-driven, never reflows.
import { revealDirective } from './directives/reveal'

// Image load-in directive (HAP-1890, parent HAP-1884 Phase 2.2). `v-img-fade="url"`
// fades card media in once the image has actually decoded (`:blur` for a blur-up)
// instead of letting it pop. Opacity-only so there's no layout shift; reduced
// motion is a full no-op (media shows immediately). WAAPI-driven, never reflows.
import { imgFadeDirective } from './directives/imgFade'

const app = createApp(sbo ? SBO : App)

app.directive('mounted', mountedDirective)
app.directive('haptic', hapticDirective)
app.directive('press', pressDirective)
app.directive('reveal', revealDirective)
app.directive('img-fade', imgFadeDirective)
app.use(Vue3TouchEvents)
app.use(VueClipboard, {
	autoSetContainer: true,
	appendToBody: true,
})

// import TawkMessengerVue from '@tawk.to/tawk-messenger-vue-3';

// if (!sbo && !window.location.href.includes('/embed/')) {
//     app.use(TawkMessengerVue, {

//         propertyId: '64e6351494cf5d49dc6c1bd0',
//         widgetId: '1h8hjumld'

//     });
// }

import { MotionPlugin } from '@vueuse/motion'

app.use(MotionPlugin, {
	directives: {},
})

import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
app.use(FloatingVue)

/*

Global Properties

*/

import breakpoints from './helpers/breakpoints'
import darkMode from './helpers/darkMode'
import formatPhone from './helpers/formatPhone'
import useCart from './helpers/cart'
import useRegistration from './helpers/registration'
import { initUser, whenUserReady } from './helpers/user'

import { apiDomain, port, useDevAPI, sentryFrontDsn } from '../../config/config/settings.json'
const isDev = import.meta.env.DEV

let api = useDevAPI ? `http://localhost:${port}` : apiDomain
if (!isDev) api = apiDomain

const breakpointsState = breakpoints().breakpoints
app.provide('breakpoints', breakpointsState)
app.provide('darkMode', darkMode().darkMode)

const user = initUser()
const cart = useCart(user)
const registration = useRegistration(user)
const store = reactive({
	user,
	...cart,
	registration,
	// HAP-5052: true from a Register click until the checkout route or a login/alert shows.
	registrationStarting: false,
	local: window.location.href.includes('localhost'),
	production: process.env.NODE_ENV == 'production',

	openType: 'popIn',
	openTypeApplied: 'popIn',
	scrollCallback: null,
	chineseMode: 'traditional',

	// Reactive reduced-motion flag (HAP-1886, parent HAP-1884). CSS animations
	// are neutralized by the @media (prefers-reduced-motion: reduce) guard in
	// index.css; JS-driven motion must read this to neutralize itself. Seeded
	// + kept live below via matchMedia.
	reducedMotion: false,

	// Whether native View Transitions drive route changes (HAP-1887, parent
	// HAP-1884). Set by installRouteTransitions() based on browser support; when
	// true, App.vue suppresses the tailwindcss-motion fallback enter classes so
	// the two don't double up.
	viewTransitions: false,

	api,

	login: {},
	nowPlaying: {},

	touchDevice: 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0,

	activeSales: window.activeSales || [],
	sbo,

	churches: [],
	bbox: null,

	median: window.median,
	hamburgerMenu: false,

	guestCheckout: {
		address: null,
		selectedAddress: null,
		guestStep: 1,
		selectedShippingMethod: null,
	},
})

if (!window.activeSales) {
	mango.discounts({ search: { type: 'sale', compareStartDate: { lessThan: new Date() }, compareEndDate: { greaterThan: new Date() } } }).then((r) => (store.activeSales = r))
}

// Keep store.reducedMotion in sync with the OS setting (HAP-1886). Lets
// JS-driven animations neutralize the same way the CSS guard does.
if (typeof window.matchMedia === 'function') {
	const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
	store.reducedMotion = reducedMotionQuery.matches
	reducedMotionQuery.addEventListener('change', (e) => (store.reducedMotion = e.matches))
}

let Authorization = window.localStorage.getItem('auth')
if (Authorization) {
    axios.defaults.headers.common['Authorization'] = Authorization
} else {
    delete axios.defaults.headers.common['Authorization']
}

// Do not treat HTTP 401 as a logout. Mango maps every collection ACL
// denial to 401 (`authorized: false`), including "this member cannot
// create in that collection." That is not a dead token — signing out
// here logged guests out after a pricing-preview / cart permission miss.
// Session death is verified explicitly via userLite (`verifySession` /
// `getUser`), not inferred from an unrelated write failing.

app.provide('store', store)
app.provide('axios', axios)

app.provide('mode', import.meta.env.MODE)
app.provide('formatPhone', formatPhone)

// Offline resource library (HAP-1422): register the dedicated offline SW so
// saved resources + the app shell are available without a connection.
import useOffline from './helpers/offline'
useOffline().register()
app.provide('offline', useOffline())

/*

Global Components

*/

import Mango from './helpers/Mango.vue'
import Spinner from './components/layout/spinner.vue'
import Modal from './components/layout/modal.vue'
import VideoFacade from './components/VideoFacade.vue'
import RegisterLabel from './components/registration/register-label.vue'

app.component('Mango', Mango)
app.component('Spinner', Spinner)
app.component('Modal', Modal)
app.component('VideoFacade', VideoFacade)
app.component('RegisterLabel', RegisterLabel)
// app.component('resource', defineAsyncComponent(Layouter.vue')))

const router = createRouter({
	history: createWebHistory(),
	scrollBehavior(to, from, savedPosition) {
		if (!to || !from) return false
		// Skip scroll promise on same-path navigations (e.g. guard redirects back to current page)
		// This avoids a double-promise that freezes touch scrolling on iOS Safari
		if (to.path === from.path) return false

		let toPath = to.matched?.[0]?.path
		let sameComponent = to.matched?.[0]?.components?.default === from.matched?.[0]?.components?.default
		let sameComponentExceptions = ['/resources/:id', /account\/*/g]
		let exceptionExists = sameComponentExceptions.some((e) => !!toPath?.match(e)?.length)
		let differentId = to.params?.id !== from.params?.id

		console.log('[scrollBehavior]', { from: from.path, to: to.path, savedPosition, sameComponent, differentId })

		if (to.hash) {
			return new Promise((resolve) => {
				let lastTop = null
				let stableTicks = 0
				let n = 0
				const stop = () => {
					clearInterval(interval)
					window.removeEventListener('wheel', stop, { passive: true })
					window.removeEventListener('touchmove', stop, { passive: true })
					window.removeEventListener('keydown', stop)
					resolve(false)
				}
				const interval = setInterval(() => {
					// A page that runs its own hash landing (FWC's landOn) sets this; stop so the two don't fight.
					if (document.documentElement.hasAttribute('data-own-hash-scroll')) return stop()
					const el = document.querySelector(to.hash)
					if (el) {
						const top = el.getBoundingClientRect().top
						if (top === lastTop) stableTicks++
						else {
							stableTicks = 0
							lastTop = top
						}
						el.scrollIntoView({ behavior: 'smooth', block: 'start' })
						if (stableTicks >= 3) return stop()
					}
					if (++n >= 16) stop()
				}, 200)
				window.addEventListener('wheel', stop, { passive: true })
				window.addEventListener('touchmove', stop, { passive: true })
				window.addEventListener('keydown', stop)
			})
		} else if (savedPosition) {
			return savedPosition
		} else if (sameComponent && !exceptionExists && !differentId) {
			return false
		} else {
			return { top: 0 }
		}
	},
	routes,
})

// HAP-4635: @sentry/vue (~190 KB raw) is fetched as its own chunk instead of
// sitting in the entry bundle. Errors thrown before it resolves (a few hundred ms
// after boot) are not reported.
// Sentry disabled (Oct 2026): cfl-front was exhausting the shared happy-path Sentry
// budget. Flip to true to re-enable once CFL has its own Sentry org.
const SENTRY_ENABLED = false
if (SENTRY_ENABLED && import.meta.env.PROD && sentryFrontDsn) import('@sentry/vue').then((Sentry) => {
	Sentry.init({
		app,
		dsn: sentryFrontDsn,
		environment: 'production',
		integrations: [Sentry.browserTracingIntegration({ router })],
		tracesSampleRate: 0.1,
		tracePropagationTargets: [apiDomain],
		// Drop the stale-deploy chunk-load-error cluster (IRO-893/IRO-1231/IRO-1233):
		// old clients holding references to chunk filenames removed by a newer deploy
		// fail dynamic imports in several browser-specific ways. router.onError below
		// already recovers from these via a hard reload, so they're non-actionable noise.
		beforeSend(event, hint) {
			const error = hint?.originalException
			const message = (error && error.message) || event?.exception?.values?.[0]?.value || ''
			if (isChunkLoadErrorMessage(message)) return null
			return event
		},
	})
})

app.use(router)

/*

Route Guard

*/

// Campaign domain isolation: visitors on marketing domains only see campaign content.
const CAMPAIGN_DOMAINS = {
	'worshipasafamily.com': '/worship-together',
	'worshipasafamily.local': '/worship-together',
	'restorefamilyworship.com': '/restore-family-worship',
	'restorefamilyworship.local': '/restore-family-worship',
}

function getCampaignScope(hostname) {
	return CAMPAIGN_DOMAINS[hostname] ?? null
}

router.beforeEach(async (to, from, next) => {
	// Campaign domain isolation: root → campaign landing; non-campaign path → campaign landing.
	const campaignPrefix = getCampaignScope(window.location.hostname)
	if (campaignPrefix) {
		if (to.path === '/') return next(campaignPrefix)
		if (!to.path.startsWith(campaignPrefix + '/') && to.path !== campaignPrefix) return next(campaignPrefix)
		return next()
	}

	console.log('[Router] beforeEach', from.path, '->', to.path, { protected: to.meta?.protected, fallback: to.meta?.fallback })
	let sboRejects = ['event', 'podcast', 'sermon', 'resource', 'product']
	if (sbo && sboRejects.some((r) => to.path.includes(r))) {
		window.location.href = `https://cf.life/${to.path}`
		return next()
	}

	let protectedRoute = to.meta?.protected

	// HAP-5052: a refresh of a protected page (e.g. checkout) used to land here before the
	// boot-time userLite returned, bounce to the fallback, then push back once it did. With a
	// stored token, wait for that load in place instead.
	let storedAuth = window.localStorage.getItem('auth')
	if (protectedRoute && !store.user?.member?.id && storedAuth && storedAuth !== 'null') await whenUserReady()

	let roles = store.user?.member?.roles
	let loggedIn = !!store.user?.member?.id
	let admin = roles?.includes('admin')
	let local = window.location.href.includes('localhost')

	if (!protectedRoute || admin || local) return next()

	let approved = Array.isArray(protectedRoute) ? protectedRoute.some((role) => roles?.includes(role)) : loggedIn

	if (approved) return next()
	else if (to.meta?.redirect) return next(to.meta.redirect)
	else {
		console.log('Protected:', protectedRoute, roles)
		store.login = { next: to.path }
		console.log('[Router] store.login set to:', JSON.stringify(store.login))

		if (!to.meta?.fallback) return next('')

		// Get params from path and add them to the fallback path (/event/:id)
		let fallback = to.meta.fallback
			?.split('/')
			?.map((p) => {
				if (p.includes(':')) {
					let param = p.replaceAll(':', '')
					return to.params[param] || ''
				} else {
					return p
				}
			})
			?.join('/')

		return next(fallback || to.meta.fallback)
	}
})

router.afterEach((to, from) => {
	console.log('[Router] afterEach', from.path, '->', to.path, 'store.login:', JSON.stringify(store.login))
	if (store.openType) store.openTypeApplied = store.openType
	store.openType = 'default'
	applyRouteMeta(to, { firstLoad: !from.matched.length })

	// SPA virtual pageview, and the SINGLE source of GA4 page_view for this site —
	// initial load included. The head gtag config sets send_page_view:false (see
	// index.html), so afterEach must keep firing on the first navigation too or the
	// landing page goes untracked. Originally added because client-side navigations
	// went untracked entirely: the old hook called window.ga() (Universal Analytics /
	// analytics.js), which this site stopped loading when it migrated to GA4, so
	// deep-linked ad landing pages reached via in-app nav registered no tag hit —
	// what Google Ads' "pages without a Google tag" warning flags. Push to the GTM
	// dataLayer so tags can be managed centrally in the GTM container, and also
	// send a GA4 page_view directly so reporting works without extra console setup.
	//
	// KNOWN REMAINING DOUBLE-COUNT on client-side navigations (HAP-3441): gtag.js
	// ALSO auto-sends its own page_view on history changes, via GA4 Enhanced
	// Measurement -> "Page changes based on browser history events" (a property-side
	// setting, not controllable from code — send_page_view:false only suppresses the
	// initial config pageview). Measured with scripts/ga4-pageview-probe.py: cold
	// load = 1 hit, in-app nav = 2. Disabling that Enhanced Measurement option in GA4
	// admin makes this hook the true single source. Until then, do NOT "fix" the nav
	// double by deleting this call — that would leave cold loads untracked entirely.
	// DECIDED 2026-07-31 (David, CFL): this hook stays as the single source and GA4
	// admin unchecks the Enhanced Measurement history-events option instead. The
	// resolution is property-side, NOT a code change here — tracked in HAP-3444.
	// Run in nextTick so document.title reflects the destination page. (HAP-1424, 3441)
	nextTick(() => {
		let pagePath = to.fullPath
		let pageLocation = window.location.origin + to.fullPath
		let pageTitle = document.title

		window.dataLayer = window.dataLayer || []
		window.dataLayer.push({
			event: 'spa_page_view',
			page_path: pagePath,
			page_location: pageLocation,
			page_title: pageTitle,
		})

		if (typeof window.gtag === 'function') {
			window.gtag('event', 'page_view', {
				page_path: pagePath,
				page_location: pageLocation,
				page_title: pageTitle,
			})
		}
	})
})

// Recover from stale dynamic-import (code-split chunk) failures. After a new
// deploy, a client still running old JS holds references to chunk filenames that
// no longer exist on the server, so lazy route imports like resource.vue reject
// with "Importing a module script failed" / "Failed to fetch dynamically imported
// module", or (when the server 404s and returns the SPA's index.html instead) a
// "'text/html' is not a valid JavaScript MIME type" error (IRO-1233). Force one
// hard reload to pick up the fresh manifest, guarding against reload loops (e.g.
// genuine network failure) with a short sessionStorage cooldown. (IRO-893)
const CHUNK_LOAD_ERROR_PATTERN =
	/Importing a module script failed|Failed to fetch dynamically imported module|error loading dynamically imported module|Unable to preload|['"]?text\/html['"]? is not a valid (?:JavaScript|JS) MIME types?/i

function isChunkLoadErrorMessage(message) {
	return CHUNK_LOAD_ERROR_PATTERN.test(message || '')
}

router.onError((error, to) => {
	const message = error?.message || String(error || '')
	if (!isChunkLoadErrorMessage(message)) return

	let last = 0
	try {
		last = Number(sessionStorage.getItem('cfl:lastChunkReload')) || 0
	} catch (e) {}
	if (Date.now() - last > 10000) {
		try {
			sessionStorage.setItem('cfl:lastChunkReload', String(Date.now()))
		} catch (e) {}
		window.location.assign(to?.fullPath || window.location.href)
	}
})
// Native route transitions (HAP-1887, parent HAP-1884 Phase 1.1): wrap route
// changes in the GPU-accelerated View Transitions API for an iOS-Settings drill
// feel, with directional push/pop, mobile-only scope, reduced-motion honoring,
// and a graceful tailwindcss-motion fallback where unsupported.
import { installRouteTransitions } from './helpers/routeTransitions'
installRouteTransitions(router, store, breakpointsState)

// // Watch for component transitions using router's navigation guards
// router.beforeResolve((to, from, next) => {
//     next(); // Proceed with navigation
//     nextTick(() => {
//         if (typeof store.scrollCallback === 'function') {
//             console.log('scrolling')
//             store.scrollCallback(); // Execute the deferred scroll
//             store.scrollCallback = null; // Reset after execution
//         }
//     });
// });

app.mount('#app')
